import { TranscparencyReceivedData } from "apiTypes";
import DonationDetailsModal from "components/ReuseableCompos/DonationDetailsModal";
import { memo, useCallback, useState } from "react";
import useModal from "../../../customHooks/useModal";
import DonationDetailsCard from "../../ReuseableCompos/DonationDetailsCard";
import InfinteDataSoruceHandler from "../../SharedLayoutComponents/InfinteDataSoruceHandler";
import DonationAccordionSkeleton from "../../Skeletons/DonationAccordionSkeleton";
type Props = {
  className?: string;
  selectedDate: string;
  donationType: string;
};
const ReceivedCards = ({ selectedDate, donationType }: Props) => {
  const [clickedDonationObj, setClickedDonationObj] =
    useState<TranscparencyReceivedData>(null);

  const {
    showModal: showModalOffCanvas,
    handleCloseModal: handleCloseModalOffCanvas,
    handleShowModal: handleShowModalOffCanvas,
  } = useModal();
  const onDonationCardClick = useCallback(
    (donationObj: TranscparencyReceivedData) => {
      setClickedDonationObj(donationObj);
      handleShowModalOffCanvas();
    },
    [handleShowModalOffCanvas]
  );

  return (
    <>
      <InfinteDataSoruceHandler
        skeleton={DonationAccordionSkeleton}
        endPoint={`transparency/donations/${donationType}?date=${selectedDate}`}
        resourceName="donation"
        skeletonAmount={6}
        getMoreSkeletonAmount={4}
        inifiteScrollClassName="overflow-hidden"
        proxy={false}
        inifiteScrollProps={{
          no100vh: true,
          style: {
            height: "100%",
          },
        }}
      >
        <DonationDetailsCard
          onDonationCardClick={onDonationCardClick}
          selectedItems={[
            "amount",
            "email",
            "name",
            "receipt_id",
            "short_name",
          ]}
        />
      </InfinteDataSoruceHandler>
      <DonationDetailsModal
        details={clickedDonationObj?.details}
        open={showModalOffCanvas}
        handleClose={handleCloseModalOffCanvas}
      />
    </>
  );
};

export default memo(ReceivedCards);
